import * as constants from './constants';

export const createImage = (payload) => ({ type: constants.CREATE_IMAGE, payload });
// eslint-disable-next-line max-len
export const createImageSuccess = (payload) => ({ type: constants.CREATE_IMAGE_SUCCESS, payload });
// eslint-disable-next-line max-len
export const createImageError = (payload) => ({ type: constants.CREATE_IMAGE_ERROR, payload });
export const resetImage = () => ({ type: constants.RESET_IMAGE });

export const createImageByUrl = (payload) => ({ type: constants.CREATE_IMAGE_BY_URL, payload });
// eslint-disable-next-line max-len
export const createImageByUrlSuccess = (payload) => ({ type: constants.CREATE_IMAGE_BY_URL_SUCCESS, payload });
// eslint-disable-next-line max-len
export const createImageByUrlError = (payload) => ({ type: constants.CREATE_IMAGE_BY_URL_ERROR, payload });
export const resetImageByUrl = () => ({ type: constants.RESET_IMAGE_BY_URL });
